var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zuke_index" },
    [
      _vm._m(0),
      _vm.guide_index == 0
        ? _c("div", { staticClass: "declare" }, [
            _c("div", { staticClass: "guide" }, [
              _c("div", { staticClass: "guide_title_box" }, [
                _c("h2", { staticClass: "guide_title" }, [
                  _vm._v("创建词条引导")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "skip",
                    on: {
                      click: function($event) {
                        return _vm.next(2)
                      }
                    }
                  },
                  [_vm._v("跳过")]
                ),
                _vm._m(1)
              ]),
              _vm._m(2),
              _c("div", { staticClass: "guide_btn" }, [
                _c("div", { staticClass: "occupy" }),
                _c(
                  "div",
                  {
                    staticClass: "guide_btn_list next",
                    on: {
                      click: function($event) {
                        return _vm.next(1)
                      }
                    }
                  },
                  [_vm._v("下一步")]
                ),
                _c("div", { staticClass: "occupy" })
              ])
            ])
          ])
        : _vm._e(),
      _vm.guide_index == 1
        ? _c("div", { staticClass: "name" }, [
            _c("div", { staticClass: "guide" }, [
              _c("div", { staticClass: "guide_title_box" }, [
                _c("h2", { staticClass: "guide_title" }, [
                  _vm._v("创建词条引导")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "skip",
                    on: {
                      click: function($event) {
                        return _vm.next(2)
                      }
                    }
                  },
                  [_vm._v("跳过")]
                ),
                _vm._m(3)
              ]),
              _vm._m(4),
              _c("div", { staticClass: "guide_btn" }, [
                _c("div", { staticClass: "occupy" }),
                _c(
                  "div",
                  {
                    staticClass: "guide_btn_list prior",
                    on: {
                      click: function($event) {
                        return _vm.next(0)
                      }
                    }
                  },
                  [_vm._v("上一步")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "guide_btn_list next",
                    on: {
                      click: function($event) {
                        return _vm.next(2)
                      }
                    }
                  },
                  [_vm._v("下一步")]
                ),
                _c("div", { staticClass: "occupy" })
              ])
            ])
          ])
        : _vm._e(),
      _vm.guide_index == 2
        ? _c("div", { staticClass: "start" }, [
            _c("div", { staticClass: "guide" }, [
              _vm._m(5),
              _c("div", { staticClass: "guide_info" }, [
                _c("h3", [_vm._v("三、开始创建")]),
                _c("div", { staticClass: "start_tips" }, [
                  _vm._v("现在选择你要创建的词条类别，开始编辑你发词条内容吧！")
                ]),
                _c(
                  "div",
                  { staticClass: "start_box" },
                  _vm._l(_vm.type, function(type, index) {
                    return _c(
                      "div",
                      {
                        staticClass: "start_list",
                        class: index == _vm.type_index ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.start_input(index)
                          }
                        }
                      },
                      [
                        _vm._m(6, true),
                        _c("div", { staticClass: "start_title" }, [
                          _vm._v(_vm._s(type))
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]),
              _c("div", { staticClass: "guide_btn" }, [
                _c("div", { staticClass: "occupy" }),
                _c(
                  "div",
                  {
                    staticClass: "guide_btn_list prior",
                    on: {
                      click: function($event) {
                        return _vm.next(1)
                      }
                    }
                  },
                  [_vm._v("上一步")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "guide_btn_list start_btn",
                    on: {
                      click: function($event) {
                        return _vm.next(3)
                      }
                    }
                  },
                  [_vm._v("开始创建")]
                ),
                _c("div", { staticClass: "occupy" })
              ])
            ])
          ])
        : _vm._e(),
      _vm.guide_index == 3
        ? _c("div", { staticClass: "fill_bg_box" }, [
            _c("div", { staticClass: "fill" }, [
              _c("div", { staticClass: "head_box" }),
              _c("div", { staticClass: "fill_type" }, [
                _c("div", { staticClass: "fill_title" }, [
                  _vm._v("当前词条类型为：" + _vm._s(_vm.type_name))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "fill_btn",
                    on: {
                      click: function($event) {
                        return _vm.next(2)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/release/baike-again.png"),
                        alt: ""
                      }
                    }),
                    _vm._v("重新选择")
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "fill_list", on: { click: _vm.city_show_btn } },
                [
                  _c("div", { staticClass: "fill_title" }, [_vm._v("城市")]),
                  _c("div", { staticClass: "fill_list_btn" }, [
                    _vm._v(_vm._s(_vm.city)),
                    _c("span", [_vm._v(">")])
                  ])
                ]
              ),
              _c("div", { staticClass: "fill_list" }, [
                _c("div", { staticClass: "fill_title" }, [_vm._v("词条名")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.fill_name,
                      expression: "fill_name",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "请输入你要创建的品牌公寓词条"
                  },
                  domProps: { value: _vm.fill_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.fill_name = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _c(
                "div",
                {
                  staticClass: "add_btn",
                  on: {
                    click: function($event) {
                      return _vm.name_test()
                    }
                  }
                },
                [_vm._v("下一步")]
              )
            ])
          ])
        : _vm._e(),
      _vm.sn_index == 1
        ? _c("div", { staticClass: "tips_box" }, [
            _c("div", { staticClass: "tips_fixed" }, [
              _c("div", { staticClass: "tips_title" }, [
                _vm._v("改词条名已存在，您可以")
              ]),
              _c("div", { staticClass: "tips_btn" }, [
                _c(
                  "div",
                  {
                    staticClass: "tips_btn_list",
                    on: { click: _vm.detail_btn }
                  },
                  [_vm._v("查看词条")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "tips_btn_list",
                    on: { click: _vm.release_btn }
                  },
                  [_vm._v("编辑已有版本")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _c("cityBox", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.city_show == 1,
            expression: "city_show == 1"
          }
        ],
        on: { func: _vm.cityBox }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head_box" }, [
      _c("div", { staticClass: "head_top_box" }, [
        _c("div", { staticClass: "head_top" }, [
          _c("a", { attrs: { href: "javascript:history.back(-1)" } }, [
            _c("img", {
              attrs: { src: require("../../assets/images/left.png"), alt: "" }
            })
          ]),
          _c("h1", [_vm._v("创建词条")]),
          _c("div", { staticClass: "head_top_btn" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_tips" }, [
      _vm._v("为了您更好的通过审核，请务必阅读租客百科的"),
      _c("span", [_vm._v("创建须知")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_info" }, [
      _c("h3", [_vm._v("一、声明")]),
      _c("div", { staticClass: "guide_tips" }, [
        _vm._v("在正式创建词条前，首先请你承诺：")
      ]),
      _c("div", { staticClass: "declare_box" }, [
        _c("div", { staticClass: "declare_list" }, [
          _vm._v(
            "1、不在租客百科添加广告性质的内容， 如联系方式，   官方网站链接等；"
          )
        ]),
        _c("div", { staticClass: "declare_list" }, [
          _vm._v("2、不在租客百科编写涉及反动，违法犯罪，色情，暴力的内容；")
        ]),
        _c("div", { staticClass: "declare_list" }, [
          _vm._v("3、不在租客百科编写虚假的、捏造的、恶搞的、缺乏根据的内容；")
        ]),
        _c("div", { staticClass: "declare_list" }, [
          _vm._v("4、不侵犯他人合理权益；")
        ]),
        _c("div", { staticClass: "declare_list" }, [
          _vm._v("5、接受违反以上规则时，租客账号会被封禁的结果。")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_tips" }, [
      _vm._v("为了您更好的通过审核，请务必阅读租客百科的"),
      _c("span", [_vm._v("创建须知")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_info" }, [
      _c("h3", [_vm._v("二、词条名")]),
      _c("div", { staticClass: "name_box" }, [
        _c("div", { staticClass: "name_list" }, [
          _c("img", {
            attrs: {
              src: require("../../assets/images/name_tips.png"),
              alt: ""
            }
          }),
          _c("div", { staticClass: "name_text" }, [
            _vm._v("请正确填写词条名，确保填写的词条名是真实存在的")
          ])
        ]),
        _c("div", { staticClass: "name_list" }, [
          _c("img", {
            attrs: {
              src: require("../../assets/images/name_tips.png"),
              alt: ""
            }
          }),
          _c("div", { staticClass: "name_text" }, [
            _vm._v(
              "如果你的词条名已经存在，你可以选择继续创建，或者去编辑已有词条"
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_title_box" }, [
      _c("h2", { staticClass: "guide_title" }, [_vm._v("创建词条引导")]),
      _c("div", { staticClass: "guide_tips" }, [
        _vm._v("为了您更好的通过审核，请务必阅读租客百科的"),
        _c("span", [_vm._v("创建须知")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input" }, [_c("p")])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/encyclopedia/guide.vue?vue&type=template&id=35300e27&scoped=true&
// module id = 337
// module chunks = 4